import type {
  CloudEnvironmentCatalogRow,
  CloudProjectCatalogRow,
} from "./cmmdForgeRuntimeListTypes";

export interface CloudEnvironmentGroup {
  /** Stable per-owner key: an Environment belongs to one (org, user) pair. */
  readonly environmentId: string;
  readonly environment: CloudEnvironmentCatalogRow;
  readonly rows: readonly CloudProjectCatalogRow[];
}

/**
 * The project rows registered on one Environment.
 *
 * CMMD issues an environment id once a VM exists; before that the runtime id is
 * the only shared handle. Both Connections and Diagnostics group by this rule,
 * so a VM with three projects on it is one row on both pages.
 */
export function projectRowsForEnvironment(
  environment: CloudEnvironmentCatalogRow,
  rows: readonly CloudProjectCatalogRow[],
): readonly CloudProjectCatalogRow[] {
  return rows.filter(
    (row) =>
      row.cmmdOrganizationId === environment.cmmdOrganizationId &&
      (environment.cmmdEnvironmentId !== null
        ? row.cmmdEnvironmentId === environment.cmmdEnvironmentId
        : row.runtimeId === environment.runtimeId),
  );
}

export function groupCloudEnvironmentRows(
  environments: readonly CloudEnvironmentCatalogRow[],
  rows: readonly CloudProjectCatalogRow[],
): readonly CloudEnvironmentGroup[] {
  return environments.map((environment) => ({
    environmentId: `${environment.cmmdOrganizationId}:${environment.cmmdUserId}:${environment.cmmdEnvironmentId ?? environment.runtimeId}`,
    environment,
    rows: projectRowsForEnvironment(environment, rows),
  }));
}
